import { render } from "./TurnaroundCalendar.vue?vue&type=template&id=3c7b0512&scoped=true"
import script from "./TurnaroundCalendar.vue?vue&type=script&lang=js"
export * from "./TurnaroundCalendar.vue?vue&type=script&lang=js"

import "./TurnaroundCalendar.vue?vue&type=style&index=0&id=3c7b0512&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7b0512"]])

export default __exports__